import { render, staticRenderFns } from "./BannerPrincipal.vue?vue&type=template&id=a2f74a42&scoped=true&"
import script from "./BannerPrincipal.vue?vue&type=script&lang=js&"
export * from "./BannerPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./BannerPrincipal.vue?vue&type=style&index=0&id=a2f74a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f74a42",
  null
  
)

export default component.exports